import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.json.stringify.js";
import { mapGetters, mapMutations } from 'vuex';
import iFrameResize from 'iframe-resizer/js/iframeResizer.min.js';
import { ctripBury, noteOpenClickBury, swiperChangeBury } from '../bury';
import { fetchData, isAndroid, isNaComponent, getUrlParams } from '../../../utils';
import { getLocation, getBosResizeUrl } from '../utils';
import { filterUrl } from '@baidu/map-fe-utils';
export default {
  props: {
    dataItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // todo 用store
    phoneInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isUseCover: {
      // iframe离屏后，是否显示占位图
      type: Boolean,
      default: false
    },
    isShowIframe: {
      // 是否显示真实iframe
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isReporting: false,
      // 首屏预加载是否结束标识
      isIframeContentLoad: false,
      // 是否使用占位图
      usePreImg: true,
      // 预加载场景是否上报展现耗时埋点
      renderBury: false,
      coverImg: '',
      startTime: 0,
      iframePreImgHeight: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters('iframe', ['iframeIndexStr', 'reportingStr'])), mapGetters('url', ['source', 'uid', 'abtest'])), mapGetters('preload', ['preImgHeight'])), mapGetters(['firstLowImg', 'is_dark', 'hasBase64'])), mapGetters('dataList', ['requestTime'])), {}, {
    iframePreLoadPicH() {
      if (this.isIframeContentLoad) {
        return 'auto';
      }
      return this.preImgHeight ? `${this.preImgHeight + 120}px` : 'auto';
    },
    iframeMinHeight() {
      // 屏幕高度
      const wWidth = window.innerWidth || window.outerWidth;
      return 3 * wWidth / 4;
    },
    preloadCondition() {
      // 命中组件包或者携程预加载实验
      return this.abtest.includes('107537') && this.dataItem.tpl_type !== 'comment' || isNaComponent();
    },
    isFirst() {
      return this.index === 0;
    },
    preloadAbtest() {
      // 首篇携程显示缩略图
      return this.preloadCondition && this.isFirst;
    },
    // 为了适应loading效果，需要对loading下面的第二篇携程笔记使用缩略图进行预渲染
    secondPreload() {
      return this.preloadCondition && this.index === 1;
    },
    // 携程笔记使用缩略图做背景，加速渲染
    showBgDv() {
      return (this.preloadAbtest || this.secondPreload || this.isUseCover) && this.usePreImg;
    },
    // iframe样式
    iframeStyle() {
      return {
        height: this.isFirst ? this.iframePreLoadPicH : 'auto',
        'min-height': (this.dataItem.tpl_type !== 'comment' ? this.iframeMinHeight : 10) + 'px',
        overflow: 'hidden'
      };
    },
    // 预渲染样式
    iframeCoverStyle() {
      var _this$dataItem, _this$dataItem2;
      // 使用预加载cover中的图或者图片列表中的第一张图
      const imgSrc = ((_this$dataItem = this.dataItem) === null || _this$dataItem === void 0 || (_this$dataItem = _this$dataItem.body) === null || _this$dataItem === void 0 || (_this$dataItem = _this$dataItem.imgList) === null || _this$dataItem === void 0 ? void 0 : _this$dataItem[0]) || ((_this$dataItem2 = this.dataItem) === null || _this$dataItem2 === void 0 || (_this$dataItem2 = _this$dataItem2.body) === null || _this$dataItem2 === void 0 || (_this$dataItem2 = _this$dataItem2.album) === null || _this$dataItem2 === void 0 || (_this$dataItem2 = _this$dataItem2.content) === null || _this$dataItem2 === void 0 || (_this$dataItem2 = _this$dataItem2[0]) === null || _this$dataItem2 === void 0 ? void 0 : _this$dataItem2.src);
      this.coverImg = this.isFirst ? imgSrc : '';
      const {
        hostname = ''
      } = getLocation(imgSrc);
      const isBcebosSrc = hostname.endsWith('.cdn.bcebos.com');
      let pic = imgSrc;
      if (isBcebosSrc && !this.isUseCover) {
        pic = getBosResizeUrl({
          src: imgSrc,
          width: 200,
          height: 200,
          focus: true
        });
      }
      // 如果没有base64图片并且没有preload，则使用缩略图的加载统计展现埋点
      const showBgImg = this.isFirst ? this.firstLowImg || pic : pic;
      this.imgRender(showBgImg);
      const imgHeight = this.isFirst ? this.preImgHeight || this.iframePreImgHeight : this.iframePreImgHeight;
      let obj = {
        width: '100%',
        height: `${imgHeight}px`,
        'background-position': 'center center',
        'background-image': `url(${showBgImg})`,
        'background-size': 'contain',
        'background-repeat': 'no-repeat'
      };
      return obj;
    }
  }),
  watch: {
    is_dark: {
      // 主题切换时，更新iframe链接is_dark参数，
      handler() {
        const {
          index
        } = this;
        const iframe = document.querySelector(`#IframeItem${index}`);
        if (iframe && iframe.src) {
          const filterIframeSrc = filterUrl(iframe.src, ['is_dark']);
          let iframeLinkSrc = this.formatIframeLink(index, filterIframeSrc);
          if (iframe) {
            iframe.setAttribute('src', iframeLinkSrc);
          }
          this.setBaiduFrame();
        }
      }
    },
    isShowIframe: {
      handler(val) {
        if (val) {
          this.inintIframeMount();
        } else {
          this.usePreImg = true;
        }
      }
    }
  },
  mounted() {
    this.inintIframeMount();
  },
  methods: _objectSpread(_objectSpread({
    inintIframeMount() {
      this.startTime = Date.now();
      const iframeSrc = this.makeIframeLink();
      if (iframeSrc === '') {
        return;
      }
      this.initIframeContainer(this.index, iframeSrc);
      // 预加载实验
      if (this.showBgDv) {
        this.handleThirdUrl();
      }
    }
  }, mapMutations({
    setIframeIndexStr: 'iframe/setIframeIndexStr',
    setReportingStr: 'iframe/setReportingStr',
    setShowTempIframe: 'login/setShowTempIframe',
    setPreImgHeight: 'preload/setPreImgHeight'
  })), {}, {
    // 占位图渲染上报笔记展现埋点
    imgRender(pic) {
      if (this.renderBury) {
        return;
      }
      this.renderBury = true;
      const img = document.createElement('img');
      img.src = pic;
      img.onload = () => {
        const endTime = Date.now();
        ctripBury(this.startTime, endTime, pic, true);
      };
    },
    // 首篇是携程笔记时，根据链接中携带的宽高比设置预占位高度
    handleThirdUrl() {
      const {
        body = {}
      } = this.dataItem;
      const {
        thirdUrl = ''
      } = body;
      const params = getUrlParams(thirdUrl);
      // 图片宽/高
      const ratio = params.imageSizeRadio || null;
      if (!ratio) {
        return;
      }
      const windowWidth = window.innerWidth || window.outerWidth;
      const iframeHeight = Math.round(windowWidth / ratio);
      if (this.preloadAbtest) {
        this.setPreImgHeight(iframeHeight);
      } else {
        // 非预加载场景，根据thirdUrl链接参数设置iframe占位高度
        this.iframePreImgHeight = Math.max(iframeHeight, windowWidth * 3 / 4);
        this.$emit('getIframeHeight', this.iframePreImgHeight + 120 + 'px');
      }
    },
    makeIframeLink() {
      var _this$dataItem3;
      const thirdUrl = ((_this$dataItem3 = this.dataItem) === null || _this$dataItem3 === void 0 || (_this$dataItem3 = _this$dataItem3.body) === null || _this$dataItem3 === void 0 ? void 0 : _this$dataItem3.thirdUrl) || '';
      return thirdUrl + '&scene=baidumap_minidetail';
    },
    // 子页面iframe链接初始化
    formatIframeLink(index, originSrc) {
      let src = originSrc;
      // 携程暗黑模式参数拼接
      if (this.is_dark) {
        src = src.indexOf('?') > -1 ? src + '&is_dark=1' : src + '?is_dark=1';
      }
      // 拼接预加载链接所需参数，首篇收起
      if (index === 0) {
        src = src + '&hideExpandBtn=0';
      }
      return src;
    },
    // 子页面iframe初始化
    initIframeContainer(index, thirdUrl) {
      let startTime = null;
      let timeSpace = 0;
      if (index > 0) {
        timeSpace = 1000;
      }
      setTimeout(() => {
        if (!this.isUseCover) {
          if (this.iframeIndexStr.indexOf(`${index}`) > -1) {
            return;
          }
          // 把索引值加到iframeIndexStr中，防止重复加载
          this.setIframeIndexStr({
            type: 'add',
            index
          });
        }
        // iframe链接
        let iframeLinkSrc = this.formatIframeLink(index, thirdUrl);
        const iframe = document.querySelector(`#IframeItem${index}`);
        if (iframe) {
          iframe.setAttribute('src', iframeLinkSrc);
          startTime = Date.now();
          // ios11 12，iframe宽度设置成100%会有问题
          // 监听子页面是否正展示，子页面无响应会上报，子页面loadPage失败会上报
          const iframeListener = setTimeout(() => {
            this.usePreImg = false;
            this.reportingHandle({
              sub_business: 'detail_load_fail',
              index
            });
          }, 4000);
          // 处理iframe渲染完isIframeContentLoad不为true的样式错乱，兜底
          if (index === 0) {
            setTimeout(() => {
              this.isIframeContentLoad = true;
            }, 2000);
          }
          iFrameResize({
            log: false,
            onMessage: messageData => {
              // 与子页面约定loadPage=true，加载完毕，noteStatus笔记状态，正常0，异常1
              const {
                loadPage,
                noteStatus,
                imgSlide = -1,
                expandClick = ''
              } = messageData.message || {};
              if (loadPage) {
                if (index === 0) {
                  this.isIframeContentLoad = true;
                  const endTime = Date.now();
                  ctripBury(startTime, endTime, iframeLinkSrc);
                }
                clearTimeout(iframeListener);
                // 延时隐藏兜底图，减轻iframe闪烁的影响
                setTimeout(() => {
                  this.usePreImg = false;
                  this.getIframeHeight();
                }, 300);
              }
              // 笔记状态异常上报
              if (noteStatus === 1) {
                this.reportingHandle({
                  sub_business: 'detail_lose_efficacy',
                  index
                });
              }
              // 轮播图滑动埋点
              if (Number(imgSlide) > -1) {
                this.ctripSwiper();
              }
              // 展开埋点
              if (expandClick) {
                noteOpenClickBury(this.index);
                this.getIframeHeight();
              }
            }
          }, `#IframeItem${index}`);
          this.setBaiduFrame();
        }
      }, timeSpace);
    },
    setBaiduFrame() {
      if (isNaComponent() && !isAndroid()) {
        // 加载携程iframe后，ios端手动修改当前域为百度域
        this.setShowTempIframe(true);
        setTimeout(() => {
          // 临时处理方案，后面需要给端提需求。
          const iframeTemp = document.querySelector('#tempIframe');
          iframeTemp.setAttribute('src', 'https://www.baidu.com/');
        }, 0);
      }
    },
    // 携程轮播图滑动
    ctripSwiper() {
      const item = this.dataItem || {};
      const obj = {
        levelOne: item.levelOne || '',
        levelTwo: item.levelTwo || '',
        tp: item.shareObj.tpSource || '',
        pmgc: item.shareObj.subSource || '',
        source: this.source || 'feed',
        note_style: 'Micro',
        unique_id: item.unique_id,
        uid: this.uid || '',
        note_index: this.index,
        user_behavior_sessionid: this.requestTime,
        abtest: this.abtest || ''
      };
      this.swiperBury(obj, this.index);
    },
    // 横滑卡滑动埋点
    swiperBury(val, index) {
      swiperChangeBury(val, index, this.phoneInfo);
    },
    /* 笔记异常上报处理, 上报类型：
     * detail_load_fail 落地页异常
     * detail_lose_efficacy 落地页失效
     * img_load_fail 图片异常
     * elem_load_fail 元素异常
     * page_cost 展示耗时
     */
    reportingHandle(val) {
      const {
        sub_business = '',
        index
      } = val || {};
      if (this.reportingStr.indexOf(`${index}`) > -1 || this.isReporting) {
        return;
      }
      this.setReportingStr({
        type: 'add',
        index
      });
      this.isReporting = true;
      const url = '/gocube/collect/report';
      const {
        cuid,
        os,
        sv
      } = this.phoneInfo || {};
      const traceData = {
        post_id: this.dataItem.unique_id
      };
      const params = {
        business: 'post',
        sub_business,
        source: this.source,
        os,
        sv,
        cuid,
        sk: '81adbe8a9adb0fb2af406b25e4679da2',
        trace_data: JSON.stringify(traceData)
      };
      fetchData(url, {
        method: 'post',
        params
      }).then(res => {
        this.isReporting = false;
      });
    },
    getIframeHeight() {
      const {
        iframeRef
      } = this.$refs;
      const iframeHeight = iframeRef && iframeRef.offsetHeight + 'px' || this.iframePreImgHeight + 'px' || 'auto';
      this.$emit('getIframeHeight', iframeHeight);
    }
  })
};